import PageBackTitle from "../../Component/PageBackTitle";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { HiOutlinePlus } from "react-icons/hi";
import { IoSearchOutline } from "react-icons/io5";
import { TbRefresh } from "react-icons/tb";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import AddProduct from "./AddProduct";
import API_URL from "../../Config";
import "../Customer/customer.css";

const ProductList = ({ isSidebarExpanded }) => {
  const [products, setProducts] = useState([]);
  const [search, setSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [loading, setLoading] = useState(false);
  const [showAdd, setShowAdd] = useState(false);

  const [snackbar, setSnackbar] = useState({
    open: false,
    msg: "",
    type: "success",
  });

  const fetchProducts = async () => {
    try {
      setLoading(true);
      const authKey = localStorage.getItem("authKey");

      const params = {
        search,
      };

      if (statusFilter !== "") {
        params.is_active = statusFilter === "1" ? "true" : "false";
      }

      const response = await axios.get(`${API_URL}/api/barrel/products`, {
        headers: { Authorization: authKey },
        params,
      });

      setProducts(response.data.products || []);
    } catch (error) {
      console.error("Error fetching products:", error);
      setSnackbar({
        open: true,
        msg: "Failed to load products",
        type: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProducts();
  }, [search, statusFilter]);

  return (
    <>
      <div
        className={`data-list-content-container page-content ${
          isSidebarExpanded ? "expanded" : "collapsed"
        }`}
      >
        <div className="data-list-content">
          {/* HEADER */}
          <div className="data-list-header">
            <div className="data-list-header-content">
              <PageBackTitle>Products</PageBackTitle>

              <div className="data-list-heading-content-right-side">
                <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                  <select
                    className="filter-dropdown"
                    value={statusFilter}
                    onChange={(e) => setStatusFilter(e.target.value)}
                    style={{ width: "100px" }}
                  >
                    <option value="">All</option>
                    <option value="1">Active</option>
                    <option value="0">Inactive</option>
                  </select>

                  <div className="search-bar-container">
                    <input
                      type="text"
                      placeholder="Search product..."
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                      className="search-bar"
                    />
                    <IoSearchOutline className="search-bar-icon" />
                  </div>

                  <button
                    className="new-button"
                    onClick={() => setShowAdd(true)}
                  >
                    <HiOutlinePlus /> New
                  </button>

                  <button
                    className="refresh-button"
                    onClick={() => fetchProducts()}
                  >
                    <TbRefresh />
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* TABLE */}
          <div className="data-list-body">
            <div className="data-list-scroll-body">
              {loading ? (
                <div className="loader-container">
                  <div className="loader"></div>
                  <div>Loading...</div>
                </div>
              ) : products.length > 0 ? (
                <table className="table multilevel-data">
                  <thead>
                    <tr>
                      <th>SR NO</th>
                      <th>PRODUCT CODE</th>
                      <th>PRODUCT NAME</th>
                      <th>UOM</th>
                      <th>STATUS</th>
                    </tr>
                  </thead>
                  <tbody>
                    {products.map((item, index) => (
                      <tr key={item.id}>
                        <td>{index + 1}</td>
                        <td>{item.product_code}</td>
                        <td>{item.product_name}</td>
                        <td>{item.uom}</td>
                        <td>
                          <span
                            className={
                              item.is_active
                                ? "status-active"
                                : "status-inactive"
                            }
                          >
                            {item.is_active ? "ACTIVE" : "INACTIVE"}
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <div className="no-users-container">
                  <div className="no-users-message">No Products Found</div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* ADD PRODUCT MODAL */}
      {showAdd && (
        <AddProduct
          onClose={() => setShowAdd(false)}
          onSuccess={() => {
            setShowAdd(false);
            fetchProducts();
          }}
        />
      )}

      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
      >
        <MuiAlert severity={snackbar.type}>{snackbar.msg}</MuiAlert>
      </Snackbar>
    </>
  );
};

export default ProductList;
